import { render } from "./DraftOrderBar.vue?vue&type=template&id=1227b482&scoped=true"
import script from "./DraftOrderBar.vue?vue&type=script&lang=js"
export * from "./DraftOrderBar.vue?vue&type=script&lang=js"

import "./DraftOrderBar.vue?vue&type=style&index=0&id=1227b482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1227b482"]])

export default __exports__